import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface SelectableTableColumn {
    key: string;
    label: string;
}

@Component({
    selector: 'app-selectable-table',
    templateUrl: './selectable-table.component.html',
    styleUrls: ['./selectable-table.component.scss'],
    standalone: false
})
export class SelectableTableComponent<T> {
    @Input() columns: SelectableTableColumn[] = [];
    @Input() rows: T[] = [];
    @Input() rowId: (row: T) => number | string = (row: T) => (row as unknown as { id: number | string }).id;
    @Input() selectedIds: Set<number | string> = new Set();
    @Input() loading = false;

    @Output() selectionChange = new EventEmitter<Set<number | string>>();

    valueFor(row: T, key: string): unknown {
        return (row as unknown as Record<string, unknown>)[key];
    }

    toggleRow(id: number | string): void {
        const next = new Set(this.selectedIds);
        if (next.has(id)) {
            next.delete(id);
        } else {
            next.add(id);
        }
        this.selectionChange.emit(next);
    }
}
